import { AppBar, Toolbar, Button, Box, Container } from '@mui/material'
import { Link } from '@inertiajs/react'
import logo from '../assets/rounded_logo.svg'

interface NavigationProps {
  loginUrl?: string;
}

export default function Navigation({ loginUrl = '/login' }: NavigationProps) {
  const isActive = (path: string) => {
    return window.location.pathname === path
  }

  return (
    <AppBar
      position="fixed"
      sx={{
        bgcolor: 'white',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        zIndex: 1100
      }}
    >
      <Container maxWidth="lg">
        <Toolbar sx={{ px: { xs: 0 } }}>
          {/* Logo */}
          <Link href="/landlord" style={{ textDecoration: 'none' }}>
            <Box
              component="img"
              src={logo}
              alt="HeyProperty"
              sx={{
                height: { xs: 32, sm: 40 },
                width: 'auto',
                cursor: 'pointer'
              }}
            />
          </Link>

          {/* Navigation Links */}
          <Box sx={{ ml: 'auto', display: 'flex', gap: 0.5 }}>
            <Link href="/pricing" style={{ textDecoration: 'none' }}>
              <Button
                sx={{
                  color: isActive('/pricing') ? 'grey.900' : 'grey.600',
                  textTransform: 'none',
                  fontWeight: isActive('/pricing') ? 600 : 400,
                  fontSize: '0.875rem',
                  '&:hover': {
                    bgcolor: 'transparent',
                    color: 'grey.900'
                  }
                }}
              >
                Pricing
              </Button>
            </Link>
            <Link href="/renters" style={{ textDecoration: 'none' }}>
              <Button
                sx={{
                  color: isActive('/renters') ? 'grey.900' : 'grey.600',
                  textTransform: 'none',
                  fontWeight: isActive('/renters') ? 600 : 400,
                  fontSize: '0.875rem',
                  '&:hover': {
                    bgcolor: 'transparent',
                    color: 'grey.900'
                  }
                }}
              >
                Renters
              </Button>
            </Link>
            <Link href="/utilities" style={{ textDecoration: 'none' }}>
              <Button
                sx={{
                  color: isActive('/utilities') ? 'grey.900' : 'grey.600',
                  textTransform: 'none',
                  fontWeight: isActive('/utilities') ? 600 : 400,
                  fontSize: '0.875rem',
                  '&:hover': {
                    bgcolor: 'transparent',
                    color: 'grey.900'
                  }
                }}
              >
                Utilities
              </Button>
            </Link>
            <Link href={loginUrl} style={{ textDecoration: 'none' }}>
              <Button
                variant="contained"
                sx={{
                  bgcolor: 'white',
                  color: 'black',
                  textTransform: 'none',
                  fontWeight: 600,
                  fontSize: '0.875rem',
                  border: '1px solid #ccc',
                  px: 3,
                  '&:hover': {
                    bgcolor: 'white',
                    color: 'black',
                    border: '1px solid #ccc'
                  }
                }}
              >
                Login
              </Button>
            </Link>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  )
}
